














































































































































  import {Component, Vue, Watch} from 'vue-property-decorator';

  import {
    全指定棚番設定型,
    商品区分型,
    棚番設定出力レコード型,
    棚番設定出力依頼型,
    棚番設定取得結果型,
    棚番設定取込不可一覧型,
    棚番設定取込不可型,
    棚番設定型,
    棚番設定更新レコード型,
    棚番設定表示条件型,
    棚番設定一覧取得結果返却型,
  } from '@/type/shelf/settings';

  import api from '@/infrastructure/api/api';
  import download from '@/infrastructure/api/download';
  import {progress} from '@/script/progress';
  import {loginModule} from '@/store/authentication/login';
  import {viewEditingStateModule} from '@/store/state/viewEditingState';

  import {ValidationResult} from '@/type/validation/result';
  import {全指定棚番設定バリデータ一覧, 棚番設定バリデータ一覧, 表示条件バリデータ一覧} from '@/type/shelf/settings-validate';

  import ButtonPanel from '@/components/menu/panel/ButtonPanel.vue';
  import IconButton from '@/components/atom/button/IconButton.vue';
  import DepartmentSelector from '@/components/department/DepartmentSelector.vue';
  import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
  import AlertDialog from '@/components/atom/dialog/AlertDialog.vue';
  import FileUploadDialog from '@/components/atom/dialog/FileUploadDialog.vue';
  import NormalButton from '@/components/atom/button/NormalButton.vue';

  import moment from 'moment';
  import CompleteDialog from '@/components/atom/dialog/CompleteDialog.vue';

  @Component({
  components: {
    CompleteDialog,
    ButtonPanel,
    IconButton,
    DepartmentSelector,
    ConfirmDialog,
    AlertDialog,
    FileUploadDialog,
    NormalButton,
  },
})

export default class ShelfSettings extends Vue {

  private 表示条件: 棚番設定表示条件型 = {
    部署コード: loginModule.部署コードを取得する,
    棚名: '',
    棚番: '',
    メーカー名: '',
    商品名カナ: '',
    商品区分: 商品区分型.指定なし,
  };
  private 全指定棚番設定: 全指定棚番設定型 = this.全指定棚番設定初期値();
  private 棚番設定リスト: 棚番設定型[] = [];
  private 棚番設定取込不可リスト: 棚番設定取込不可型[] = [];

  private 商品区分一覧: string[] = [
    商品区分型.医薬品,
    商品区分型.その他品,
    商品区分型.指定なし,
  ];

  private 選択中の行index: number|null = null;
  private アップロードファイル: File | null = null;
  private 取込結果を表示する: boolean = false;

  private アラートメッセージ: string | string[] | null = null;
  private 表示条件バリデーション結果: ValidationResult = new ValidationResult(表示条件バリデータ一覧);
  private 棚番設定バリデーション結果: ValidationResult = new ValidationResult(棚番設定バリデータ一覧);

  @Watch('棚番設定リスト', {deep: true})
  private リストが変更された() {
    if (!this.表示件数が0件) {
      viewEditingStateModule.画面の編集を開始する();
    } else {
      viewEditingStateModule.画面の編集を終了する();
    }
  }

  private created() {
    viewEditingStateModule.初期化する();
  }

  private beforeUpdate(): void {
    this.表示条件バリデーション結果.validate(this.表示条件);
    this.棚番設定バリデーション結果.validateList(this.棚番設定リスト);
  }

  private get 表示件数を取得() {
    return this.棚番設定リスト.length;
  }

  private get 表示件数が0件() {
    return this.表示件数を取得 === 0;
  }

  private get 取込エラー件数を取得() {
    return this.棚番設定取込不可リスト.length;
  }

  private get 取込確認メッセージ() {
    let 編集中追加文言: string = '';
    if (viewEditingStateModule.画面を編集中である) {
      編集中追加文言 = '編集中のデータは破棄されます。';
    }

    return 編集中追加文言 + '棚番設定を取込しますか？';
  }

  private 代行ログインである(): boolean {
    return loginModule.マスターである;
  }

  private 絞込条件入力エラー判定表示(項目名: string) {
    return {'input-error': this.絞込条件入力エラー判定(項目名)};
  }

  private 絞込条件入力エラー判定(項目名: string): boolean {
    return this.表示条件バリデーション結果.hasError(項目名);
  }

  private 棚番入力エラー判定表示(index: number, 項目名: string) {
    return {'input-error': this.棚番入力エラー判定(index, 項目名)};
  }

  private 棚番入力エラー判定(index: number, 項目名: string): boolean {
    if (this.棚番設定バリデーション結果.hasError(項目名, index)) {
      return true;
    }

    return this.棚名棚番入力エラー判定(this.棚番設定リスト[index].棚名, this.棚番設定リスト[index].棚番);
  }

  private 棚名棚番入力エラー判定(棚名: string|null, 棚番: string|null): boolean {
    return (棚名 === null || 棚名.length === 0) && (棚番 !== null && 棚番.length !== 0);
  }

  private 棚名棚番リストエラー判定(): boolean {
    return this.棚番設定リスト.filter((棚番設定: 棚番設定型) => this.棚名棚番入力エラー判定(棚番設定.棚名, 棚番設定.棚番)).length !== 0;
  }

  private async 棚番設定を取得するハンドラ() {
    if (this.表示条件バリデーション結果.hasErrors) {
      this.アラートメッセージ = this.表示条件バリデーション結果.getMessages();
      this.$modal.show('アラート');
      return;
    }

    if (viewEditingStateModule.画面を編集中である) {
      this.ダイアログを開く('編集中検索確認ダイアログ');
      return;
    }

    await progress(this.棚番設定を取得する);
  }

  private async 破棄確認後に棚番設定を取得するハンドラ() {
    this.ダイアログを閉じる('編集中検索確認ダイアログ');
    await progress(this.棚番設定を取得する);
  }

  private async 棚番設定を取得する() {
    this.取込結果を表示する = false;

    const 棚番設定取得依頼: 棚番設定表示条件型 = {
      部署コード: this.表示条件.部署コード,
      棚名: this.表示条件.棚名,
      棚番: this.表示条件.棚番,
      メーカー名: this.表示条件.メーカー名,
      商品名カナ: this.表示条件.商品名カナ,
      商品区分: this.表示条件.商品区分 === 商品区分型.指定なし ? null : this.表示条件.商品区分,
    };

    await api.棚番設定を取得する(棚番設定取得依頼)
    .then((response: 棚番設定一覧取得結果返却型) => {
      this.棚番設定リスト = response.棚番設定リスト.map((棚番設定: 棚番設定取得結果型) => {
        return {
          key: 棚番設定.部署コード + 棚番設定.商品コード,
          商品コード: 棚番設定.商品コード,
          商品区分: 棚番設定.商品区分,
          棚番リビジョン番号: 棚番設定.棚番リビジョン番号,
          メーカー名: 棚番設定.メーカー名,
          商品名: 棚番設定.商品名,
          規格容量: 棚番設定.規格容量,
          棚名: 棚番設定.棚名,
          更新前棚名: 棚番設定.棚名,
          棚番: 棚番設定.棚番,
          更新前棚番: 棚番設定.棚番,
          部署コード: 棚番設定.部署コード,
          部署名: 棚番設定.部署名,
        };
      });
      this.選択中の行index = null;
      this.棚番設定取込不可リスト = [];
      this.取込結果を表示する = false;

      if (response.アラートメッセージ) {
        this.アラートメッセージ = response.アラートメッセージ;
        this.$modal.show('アラート');
      }

    }).catch((error: any) => {
      this.APIアラートダイアログを開く(error.data);
      return;
    });

    viewEditingStateModule.画面の編集を終了する();
  }

  private async 棚番設定を保存するハンドラ() {
    if (this.棚番設定リスト.length === 0) {
      return;
    }

    this.アラートメッセージ = [];

    if (this.棚番設定バリデーション結果.hasErrors) {
      this.アラートメッセージ = Array.from(new Set(this.棚番設定バリデーション結果.getMessages()));
    }

    if (this.棚名棚番リストエラー判定()) {
      this.アラートメッセージ.push('棚名未設定の商品に対して棚番の設定は出来ません');
    }

    if (this.アラートメッセージ.length !== 0) {
      this.$modal.show('アラート');
      return;
    }

    await progress(this.棚番設定を保存する);
  }

  private async 棚番設定を保存する(): Promise<void> {
    const 更新棚番設定リスト: 棚番設定更新レコード型[] = this.棚番設定リスト
            .map((棚番設定: 棚番設定型) => {
              return {
                部署コード: 棚番設定.部署コード,
                商品コード: 棚番設定.商品コード,
                棚番リビジョン番号: 棚番設定.棚番リビジョン番号,
                棚名: 棚番設定.棚名,
                棚番: 棚番設定.棚番,
              };
            });

    const 棚番設定更新依頼 = {
      棚番設定更新リスト: 更新棚番設定リスト,
    };

    await api.棚番設定を更新する(棚番設定更新依頼)
    .then((response: any) => {
      this.棚番設定を取得する();

    }).catch((error: any) => {
      this.APIアラートダイアログを開く(error.data);
      return;
    });
  }

  private ファイル名を取得する() {
    const now = new Date();
    moment.locale('ja');
    return '棚番設定_' + moment(now).format('YYYYMMDDhhmmss') + '.xlsx';
  }

  private async 棚番設定の出力前エラーチェックをする() {
    if (this.表示条件バリデーション結果.hasErrors) {
      this.アラートメッセージ = this.表示条件バリデーション結果.getMessages();
      this.$modal.show('アラート');
      return;
    }

    this.ダイアログを開く('出力ダイアログ');
  }

  private async 棚番設定を出力するハンドラ() {
    this.ダイアログを閉じる('出力ダイアログ');
    await progress(this.棚番設定を出力をする);
  }

  private async 棚番設定を出力をする(): Promise<void> {
    const 棚番設定取得依頼: 棚番設定表示条件型 = {
      部署コード: this.表示条件.部署コード,
      棚名: this.表示条件.棚名,
      棚番: this.表示条件.棚番,
      メーカー名: this.表示条件.メーカー名,
      商品名カナ: this.表示条件.商品名カナ,
      商品区分: this.表示条件.商品区分 === 商品区分型.指定なし ? null : this.表示条件.商品区分,
    };

    const ファイル名 = this.ファイル名を取得する();
    await download.棚番設定一覧表を出力する(ファイル名, 棚番設定取得依頼)
      .catch((error: any) => {
        this.APIアラートダイアログを開く(error.data);
        return;
      });
  }

  private async 棚番設定取込をするハンドラ(アップロードファイル: File) {
    this.アップロードファイル = アップロードファイル;
    await progress(this.棚番設定取込をする);
  }

  private async 棚番設定取込をする(): Promise<void> {
    if (this.アップロードファイル === null) {
      return;
    }

    const params = new FormData();
    params.append('name', this.アップロードファイル.name);
    params.append('file', this.アップロードファイル);
    await api.棚番設定のExcel取込をする(params)
      .then((response: 棚番設定取込不可一覧型) => {
        this.棚番設定取込不可リスト = response.棚番設定取込不可リスト;
        this.棚番設定リスト = [];
        this.取込結果を表示する = true;
        if (this.棚番設定取込不可リスト.length > 0) {
          this.アラートメッセージ = ['一部更新できませんでした。', 'エラー内容をご確認ください。'];
          this.ダイアログを開く('アラート');
          return;
        }
        this.ダイアログを開く('取込完了ダイアログ');
      }).catch((error: any) => {
        this.APIアラートダイアログを開く(error.data);
        return;
      });
  }

  private 全指定棚番設定初期値(): 全指定棚番設定型 {
    return {
      棚名: null,
      棚番: null,
    };
  }

  private 棚名棚番を全指定する() {
    const 全指定棚番設定バリデーション結果: ValidationResult = new ValidationResult(全指定棚番設定バリデータ一覧);
    全指定棚番設定バリデーション結果.validate(this.全指定棚番設定);
    if (全指定棚番設定バリデーション結果.hasErrors) {
      this.アラートメッセージ = 全指定棚番設定バリデーション結果.getMessages();
      this.$modal.show('アラート');
      return;
    }

    this.棚番設定リスト = this.棚番設定リスト
          .map((棚番設定: 棚番設定型) => {
            return {
              key: 棚番設定.key,
              商品コード: 棚番設定.商品コード,
              商品区分: 棚番設定.商品区分,
              棚番リビジョン番号: 棚番設定.棚番リビジョン番号,
              メーカー名: 棚番設定.メーカー名,
              商品名: 棚番設定.商品名,
              規格容量: 棚番設定.規格容量,
              棚名: this.全指定棚番設定.棚名,
              棚番: this.全指定棚番設定.棚番,
              部署コード: 棚番設定.部署コード,
              部署名: 棚番設定.部署名,
            };
          });
  }

  private ダイアログを開く(name: string): void {
    this.$modal.show(name);
  }

  private ダイアログを閉じる(name: string): void {
    this.$modal.hide(name);
  }

  private APIアラートダイアログを開く(data: any) {
    this.アラートメッセージ = [data.message];
    if (data.errors !== undefined) {
      for (const エラー of Array.from(new Set(data.errors))) {
        this.アラートメッセージ = this.アラートメッセージ.concat(['・' + エラー]);
      }
    }
    this.ダイアログを開く('アラート');
  }

  private async リスト選択時の処理(index: number) {
    if (this.選択中の行index !== index) {
      this.選択中の行index = index;
    }
  }

  private 行が選択されている(index: number) {
    return this.選択中の行index === index;
  }
}
